if($('.code_field').length) {
    $(".code_field").inputmask({"mask": "*99-***-*99-***-99*", "greedy": false});
}